(function () {
  'use strict';

  if (!document.getElementById('wig-retention-modal')) return;

  const STORAGE_KEY = 'wig_retention_shown';
  const modal = document.getElementById('wig-retention-modal');
  const IDLE_MS = 45000;
  const GUIDE_THRESHOLD = 2;

  let guideOpens = 0;
  let idleTimer = null;
  let shown = sessionStorage.getItem(STORAGE_KEY) === '1';

  const track = (eventName, data = {}) => {
    document.dispatchEvent(new CustomEvent('wig:analytics', {
      detail: { event: eventName, page_type: 'product', ...data },
    }));
  };

  const openModal = (reason) => {
    if (shown || !modal) return;
    shown = true;
    sessionStorage.setItem(STORAGE_KEY, '1');
    modal.showModal();
    track('retention_modal_open', { reason });
  };

  const closeModal = () => {
    modal?.close();
    track('retention_modal_close');
  };

  modal?.querySelector('[data-retention-close]')?.addEventListener('click', closeModal);
  modal?.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });
  modal?.querySelector('[data-retention-guide]')?.addEventListener('click', () => {
    closeModal();
    document.getElementById('wig-size-guide')?.scrollIntoView({ behavior: 'smooth' });
    track('retention_modal_guide_click');
  });
  modal?.querySelector('[data-retention-support]')?.addEventListener('click', () => {
    track('retention_modal_support_click');
  });

  const resetIdle = () => {
    if (shown) return;
    if (idleTimer) window.clearTimeout(idleTimer);
    idleTimer = window.setTimeout(() => openModal('idle_no_atc'), IDLE_MS);
  };

  document.addEventListener('wig:analytics', (event) => {
    const name = event.detail?.event;
    if (name === 'add_to_cart') {
      shown = true;
      sessionStorage.setItem(STORAGE_KEY, '1');
      if (idleTimer) window.clearTimeout(idleTimer);
    }
    if (name === 'size_guide_open') {
      guideOpens += 1;
      if (guideOpens >= GUIDE_THRESHOLD) openModal('size_guide_repeat');
    }
  });

  ['scroll', 'pointerdown', 'keydown'].forEach((type) => {
    document.addEventListener(type, resetIdle, { passive: true });
  });

  window.addEventListener('pagehide', () => {
    if (shown || !document.querySelector('[data-product-form]')) return;
    if (performance.navigation?.type === 2) openModal('back_navigation');
  });

  resetIdle();
})();
